import React, { Component } from 'react';
import PropTypes from 'prop-types';

import EditableInput from '../EditableInput';

class WebsiteRow extends Component {
	handleInputChange = (field, value) => {
		this.props.onChange(value, this.props.rowKey);
	}

	render () {
		const { isEditMode, rowData } = this.props;

		return <div className="col-xs-12">
			<div className="col-xs-2 custom-form__label">Сайт:</div>
			<div className="col-xs-3">
				<EditableInput type="text" value={rowData} onChange={this.handleInputChange} name="website" editMode={!isEditMode || !rowData} />
			</div>
		</div>
	}
}

WebsiteRow.propTypes = {
	onChange: PropTypes.func.isRequired,
	rowData: PropTypes.string,
	rowKey: PropTypes.number.isRequired,
	isEditMode: PropTypes.bool
}

export default WebsiteRow;



// WEBPACK FOOTER //
// ./components/ClientForm/Websites/WebsiteRow.js